import { selectTagsInitWaitingMessage } from './../_selectors/tags.selectors';
// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectTagsInStore, selectTagsPageLoading } from '../_selectors/tags.selectors';

export class TagsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectTagsPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectTagsInitWaitingMessage)
		);

		this.store.pipe(
			select(selectTagsInStore)
		).subscribe((response: QueryResultsModel) => {
            //console.log('The res is',response)
			this.paginatorTotalSubject.next(response.resultCount);
			this.entitySubject.next(response.list);
		});
	}
}
